export default {
    isLoggin() {
        return localStorage.getItem("X-Auth-Token")? true : false;
    }
}